var React = require('react');

function IconClockSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"}));
}

IconClockSolid.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = IconClockSolid;

IconClockSolid.default = IconClockSolid;
